export const SHOW_SNACKBAR = 'notifications/SHOW_SNACKBAR';
export const REMOVE_SNACKBAR = 'notifications/REMOVE_SNACKBAR';

export const NOTIFICATIONS_KEY = 'notifications';
